import styled, { css } from 'styled-components';
import { SecondaryButton, H3, SectionText } from 'styles/Typography.styled';

export const LocaleBox = styled.div(
    ({ theme: { colors } }) => css`
        margin-bottom: 32px;
        background-color: ${colors.white};
        width: 100%;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: center;
        padding: 36px;
    `,
);

export const Title = styled(H3)`
    padding-bottom: 8px;
    line-height: 36px;
`;

export const TextWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const StyledLocalStatus = styled.p<{ isFree?: string }>(
    ({ theme: { colors, fontWeight, fontSizes }, isFree }) => css`
        color: ${isFree === 'Wolne'
            ? colors.green
            : isFree === 'Sprzedane'
            ? colors.error
            : colors.yellow};
        font-weight: ${fontWeight.semiBold};
        font-size: ${fontSizes.f12};
        line-height: 16px;
        padding-bottom: 16px;
        text-transform: uppercase;
    `,
);

export const StyledText = styled(SectionText)(
    ({ theme: { colors, fontWeight, fontSizes } }) => css`
        color: ${colors.neutral900};
        font-weight: ${fontWeight.bold};
        font-size: ${fontSizes.f14};
    `,
);

export const YardgeText = styled.div(
    ({ theme: { colors, fontWeight, fontSizes } }) => css`
        white-space: nowrap;
        color: ${colors.neutral900};
        font-weight: ${fontWeight.medium};
        font-size: ${fontSizes.f14};
    `,
);

export const PriceText = styled.span(
    ({ theme: { colors, fontSizes, fontWeight, letterSpacing } }) => css`
        white-space: nowrap;
        color: ${colors.primaryBlue400};
        font-size: ${fontSizes.f24};
        font-weight: ${fontWeight.bold};
        letter-spacing: ${letterSpacing.xl};
    `,
);

export const StyledButton = styled(SecondaryButton)`
    width: 100%;
    align-self: center;
    margin-top: 32px;
    svg {
        margin-right: 12px;
    }
`;
